module.exports = __webpack_public_path__ + "static/media/block-img-five.dbf4d7dd.svg";